import { useEffect, useState, useCallback, useRef } from 'react';

// This hook no longer registers the SW (that's handled in index.js)
// It only provides update state for UI purposes
export const useServiceWorker = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const applyUpdate = useCallback(() => {
    // The auto-update in index.js handles this
    window.location.reload();
  }, []);

  return { updateAvailable, applyUpdate };
};

export const ServiceWorkerUpdater = () => {
  useServiceWorker();
  return null;
};

export default useServiceWorker;
